export default __webpack_public_path__ + "e569bbdf4b606c500438a8bae324da12.png";